import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { TableBody, Table, TableHead, TableRow, TableContainer, TableCell } from '@mui/material';
import PlaceholderEmptyList from 'components/PlaceholderEmptyList';
import LoanPartsMobileTable from './LoanPartMobileTable';
import LoanPartRow from './LoanPartRow';
import { IsMobile } from 'utils/global';
import BridgingRow from '../Bridging/BridgingRow';
import { ClientDetailsBridging } from 'types/ClientDetails/ClientDetailsBridging';
import { ClientDetailsLoanParts } from 'types/ClientDetails/ClientDetailsLoanParts';

type LoanPartsDetailsProps = {
  loanParts?: ClientDetailsLoanParts[];
  bridgings?: ClientDetailsBridging[];
};

const LoanPartsDetails: FC<LoanPartsDetailsProps> = ({ loanParts, bridgings }) => {
  const { t } = useTranslation();
  const translationsRootLoanParts = 'clients.clientData.loan.loanParts';
  const translationsRootBridgings = 'clients.clientData.loan.bridgings';
  const isMobile = IsMobile();

  if (!loanParts || !loanParts.length) {
    return <PlaceholderEmptyList title={t(`${translationsRootLoanParts}.none`)} />;
  }

  if (isMobile) {
    return (
      <>
        {loanParts?.map((loanPart, index) => (
          <LoanPartsMobileTable
            key={index}
            loanPart={loanPart}
            translationsRoot={translationsRootLoanParts}
          />
        ))}
      </>
    );
  }

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell align="left">{t(`${translationsRootLoanParts}.part`)}</TableCell>
            <TableCell sx={{ maxWidth: '136px' }} align="left">
              {t(`${translationsRootLoanParts}.originalAmount`)}
            </TableCell>
            <TableCell sx={{ maxWidth: '100px' }} align="left">
              {t(`${translationsRootLoanParts}.remainingAmount`)}
            </TableCell>
            <TableCell align="left">{t(`${translationsRootLoanParts}.interestRate`)}</TableCell>
            <TableCell align="left">{t(`${translationsRootLoanParts}.progress`)}</TableCell>
            <TableCell align="left" padding="checkbox" />
          </TableRow>
        </TableHead>
        <TableBody>
          {loanParts?.map((loanPart, index) => (
            <LoanPartRow
              loanPart={loanPart}
              key={index}
              translationsRoot={translationsRootLoanParts}
            />
          ))}
          {bridgings?.map((bridging, index) => (
            <BridgingRow
              bridging={bridging}
              key={index}
              translationsRoot={translationsRootBridgings}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default LoanPartsDetails;
